<template>
  <div class="informationDetails">
    <cms-header></cms-header>
    <!--面包屑-->
    <div class="width_width child_bg_zx">
      <div class="width_w clearfix cms-container">
        <div class="now_add left clearfix">
          <router-link class="now_a left" to="/">首页</router-link>
          <img class="now_arrow left" src="../../assets/image/pc/jiantou.svg"/>
          <router-link to="/information">
            <a class="now_a left" href="#">资讯中心</a>
          </router-link>
          <img class="now_arrow left" src="../../assets/image/pc/jiantou.svg"/>
          <router-link to="/informationDetails">
            <a class="now_a left" href="#">文章详情</a>
          </router-link>
        </div>
      </div>
      <span class="child_name">文章详情</span>
    </div>
    <div class="cms-container notice-info">
      <div class="notice-left left">
        <div class="news_child">
          <div class="child_title">
            <span class="child_span">{{ content.contentTitle }}</span>
            <span class="child_time">{{ content.contentDatetime }}</span>
          </div>
          <div class="child_content" v-html="content.contentDetails">
          </div>
        </div>
      </div>
    </div>
    <cms-foot class="left"></cms-foot>
  </div>
</template>

<script>

import CmsHeader from "../../components/commoon/component/cms-header";
import CmsFoot from "../new-home/cms-foot";

export default {
  name: "informationDetails",
  components: {CmsFoot, CmsHeader,},
  data() {
    return {
      content: {},
      configForm: {},
      query: {},
    }
  }, methods: {
    getConfigs: function (id) {
      var that = this;
      this.$http.get(that.base + "/content/getCall.do", {
        params: {
          id: id
        }
      }).then(function (res) {
        var data = res.data.result;
        if (data) {
          that.configForm = data;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getParameter: function (paraName) {
      var url = document.location.toString();
      //去除路由的#号
      if (url.lastIndexOf('#') == (url.length - 1)) {
        url = url.substring(0, url.lastIndexOf('#'));
      }
      var arrObj = url.split("?");
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    get: function (myId, type) {
      var that = this;
      if (type != null && type != '') {
        that.$http.get(that.base + "/innerBulletin/get.do", {
          params: {
            id: myId
          }
        }).then((data) => {
          that.content = data.data.result;
          that.content.contentTitle = data.data.result.theme;
          that.content.contentDatetime = data.data.result.publicityBeginTime + " ~ " + data.data.result.publicityEndTime;
          that.content.contentDetails = data.data.result.content;
        }).catch((error) => {
          console.log(error)
        })
      } else {
        that.$http.get(that.base + "/content/get.do", {
          params: {
            id: myId
          }
        }).then(function (data) {
          that.content = data.data.result
        }).catch(function (error) {
          console.log(error)
        })
      }
    },
  }, created() {
    /*初始化卡片*/
    this.getConfigs(203);
    var id = this.getParameter("id");
    var type = this.getParameter("type");
    this.get(id, type);
    document.title = this.title;

  }
}
</script>
<style scoped lang="css" src="../../assets/commoon/css/common.css"></style>
<style scoped>
.notice-left{
  width: 100%!important;
}
</style>


